import { getBeatByUserType } from "../../Slice/beat.slice";
import { getOutletByBeatsAndAssignedStockHolder } from "../../Slice/outlet.slice";
import {
  getOutletOrderDetailUpdated,
  getOutletOrderDetailBySalesNew,
  setOutletOrderDetail,
} from "../../Slice/outletOrderDetail.slice";
import { getRateEditOrNot } from "../../Slice/rateConfigurationEditingForStockholder.slice";
import {
  getSalesExecutiveByBeatIds,
  getSalesExecutiveByLoginAreas,
} from "../../Slice/salesExecutive.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";

export const mapStateToProps = (state) => ({
  areaList: state.area,
  outletList: state.outlet,
  beatList: state.beat,
  outletOrderDetail: state.outletOrderDetail,
  salesExecutive: state.salesExecutive,
  stockHolderAndProductConfiguration: state.stockHolderAndProductConfiguration,
});

export const mapDispatchToProps = {
  showNotification,
  showLoador,
  getBeatByUserType,
  getOutletByBeatsAndAssignedStockHolder,
  getSalesExecutiveByBeatIds,
  setOutletOrderDetail,
  getOutletOrderDetailUpdated,
  getRateEditOrNot,
  getOutletOrderDetailBySalesNew,
  getSalesExecutiveByLoginAreas,
};
